module.exports = __webpack_public_path__ + "static/media/individual_03.259a4f15.jpg";